<template>
  <div class="card card-modal">
    <div class="card-header">
      <b>Faturamento de cliente: {{ form.razaoSocial }} - Modelo de email</b>
    </div>

    <div class="card-body">
      <div class="row" v-if="loadingData && !error">
        <img class="col-4 mx-auto" src="./../assets/images/spinner.svg" />
        <div class="col-12 text-center">
          <p>{{log}}</p>
        </div>
      </div>

      <div class="alert alert-danger text-center" v-if="cliSemValorSms.length > 0">
        <span v-for="cli in cliSemValorSms">{{cli.nome}} ,</span> sem valor por smss, informe os valores abaixo
      </div>

      <div class="alert alert-danger text-center" v-if="error">{{ error }}</div>

      <div class="alert alert-success text-center" v-if="successMsg">{{ successMsg }}</div>

      <div class="row" v-if="!loadingData && !successMsg ">
        <div class="col-sm-12 col-md-6">
          <h5 class="text-center">Dados de preenchimento do email</h5>
          <div class="row">
            <div class="form-group col-12">
              <label for="msgCustom">Mensagem inicial</label>
              <textarea id="msgCustom" rows="3" v-model="form.msgCustom" class="form-control col-12"></textarea>
            </div>

            <div class="form-group col-12">
              <label for="razaoSocial">Razao Social</label>
              <input
                type="text"
                class="form-control"
                v-model="form.razaoSocial"
                name="razaoSocial"
                id="razaoSocial"
              />
            </div>

            <div class="form-group col-12">
              <label for="cnpj">CNPJ</label>
              <input type="text" class="form-control" v-model="form.cnpj" name="cnpj" id="cnpj" />
            </div>

            <div class="form-group col-6">
              <label for="emissao">Data de emissão:</label>
              <input
                type="date"
                class="form-control"
                v-model="form.emissao"
                name="emissao"
                id="emissao"
              />
            </div>

            <div class="form-group col-6">
              <label for="vencimento">Data do vencimento:</label>
              <input
                type="date"
                class="form-control"
                v-model="form.vencimento"
                name="vencimento"
                id="vencimento"
              />
            </div>

            <div class="form-group col-12">
              <label for="emailDestinatario">Email de destino</label>
              <input
                type="text"
                class="form-control"
                v-model="form.emailDestinatiario"
                name="emailDestinatario"
                id="emailDestinatario"
                placeholder="email1@email.com;email2@email.com"
              />
              <small id="helpId" class="form-text text-muted">Apenas emails separados por ';'</small>
            </div>

            <divider />

            <div class="col-12">
              <h5 class="text-center">Valor por sms</h5>
            </div>

            <div class="form-group col-12">
              <div class="col-12" v-for="cli in form.clientes">
                <div class="row">
                  <div class="input-group mb-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text col-12">{{cli.nome}} - R$</div>
                    </div>
                    <input
                      type="number"
                      class="form-control"
                      name="valorSms"
                      id="valorSms"
                      v-model="cli.valorSms"
                      @change="calcValorTotal()"
                    />
                    <div class="input-group-append">
                      <div class="input-group-text col-12">x {{cli.entregues | number }} smss</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group col-12  text-center">
              <label >
                Valor total a ser cobrado: (soma dos clientes)
                <br>
                <b>
                  <small>(total smss * valor smss = valor total)</small>
                </b>
              </label>

              <div class="col-12">
                <div class="row">
                  <h3 class="col-12">
                    {{ form.valorTotal | money}}
                  </h3>
                </div>
              </div>
            </div>

            <divider />

            <div class="col-12">
              <h5 class="text-center">Anexos</h5>
            </div>

            <div class="form-group col-sm-12 col-md-6">
              <label for="vencimento">Nota fiscal:</label>
              <label for="nota-upload" class="btn col-12 btn-sm btn-info">Escolher nota</label>
              <input
                id="nota-upload"
                type="file"
                style="display: none"
                ref="myFile"
                @change="choseNota"
              />
              <small>{{fileNota.name}}</small>
            </div>

            <div class="form-group col-sm-12 col-md-6">
              <label for="vencimento">Boleto:</label>
              <label for="bol-upload" class="btn col-12 btn-sm btn-info">Escolher boleto</label>
              <input
                id="bol-upload"
                type="file"
                style="display: none"
                ref="myFile"
                @change="choseBol"
              />
              <small>{{fileBol.name}}</small>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-md-6">
          <h5 class="text-center">Corpo do email</h5>

          <div class="alert alert-info">
            <p style="white-space: pre-line;">
              {{form.msgCustom}}
            </p>

            <p>
              <u>
                <b>Detalhes do serviço</b>
              </u>
            </p>

            <p>
              <u>Razão Social</u>
              : {{form.razaoSocial}}
            </p>
            <p>
              <u>CNPJ</u>
              : {{form.cnpj}}
            </p>

            <p>
              <b>Data de emissão da nota fiscal: {{form.emissao | date }}</b>
            </p>
            <p>
              <b>Vencimento: {{form.vencimento | date }}</b>
            </p>
            <p>
              <b>Valor total: {{form.valorTotal | money }}</b>
            </p>
            <p>
              <b>Quantidade de sms total: {{form.totalEntregues | number}}</b>
            </p>

            <p>Dúvidas entre em contato</p>
            <p>At.</p>

            <divider />

            <p>Anexos:</p>
            <ul>
              <li>
                <b>Nota:</b>
                {{fileNota.name}}
              </li>
              <li>
                <b>Boleto:</b>
                {{fileBol.name}}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row card-footer">
      <div class="col">
        <button class="btn btn-md col" @click="$emit('close')">Fechar</button>
      </div>
      <div class="col" v-if="!loadingData && !successMsg">
        <button class="btn btn-info btn-md col" @click="saveClientes()">Salvar dados cliente</button>
      </div>
      <div class="col" v-if="!loadingData && !successMsg">
        <button
          class="btn btn-success btn-md col btn-success"
          @click="confirm()"
        >Salvar e confirmar faturamento</button>
      </div>
    </div>
  </div>
</template>


<script>
import moment from "moment";
import axios from "axios";
import EventBus from "./../core/eventBus";

export default {
  props: ["grupo", "mes", "mesIndex", "ano", "anoIndex"],
  data() {
    return {
      log: "",
      error: false,
      successMsg: false,
      form: {
        valorTotal: 0,
        emissao: moment().format("YYYY-MM-DD"),
        vencimento: moment().format("YYYY-MM-DD"),
        razaoSocial: "",
        cnpj: "",
        totalEntregues: 0,
        emailDestinatiario: "",
        clientes: [],
        msgCustom: '',
      },
      fileBol: {},
      fileNota: {},
      cliSemValorSms: [],
      loadingData: true,
      meses: {
        0: "Janeiro",
        1: "Fevereiro",
        2: "Março",
        3: "Abril",
        4: "Maio",
        5: "Junho",
        6: "Julho",
        7: "Agosto",
        8: "Setembro",
        9: "Outubro",
        10: "Novembro",
        11: "Dezembro"
      }
    };
  },
  computed: {
    getDate(date) {
      return moment(date).format("YYYY-MM-DD");
    }
  },
  methods: {
    async saveClientes() {
      return new Promise(async resolve => {
        const dataPost = {
          clientes: this.form.clientes,
          vencimento: this.form.vencimento,
          emailDestinatiario: this.form.emailDestinatiario,
          razaoSocial: this.form.razaoSocial,
          cnpj: this.form.cnpj
        };

        const resp = await this.$http.post(
          "/v1/financeiro/faturamento/saveClientes",
          dataPost
        );

        if (resp.success) {
          this.$toasted.success("Clientes atualizados com sucesso", {
            icon: "error"
          });
          resolve(true);
        } else {
          this.$toasted.error(resp.err, { icon: "times" });
          resolve(true);
        }
      });
    },
    async confirm() {
      this.error = false;
      this.successMsg = false;

      if (
        // this.fileBol.name &&
        // this.fileNota.name &&
        this.form.valorTotal > 0 &&
        this.form.totalEntregues &&
        this.form.emailDestinatiario &&
        this.form.cnpj &&
        this.form.razaoSocial
      ) {
        await this.saveClientes();

        this.form.mes = this.meses[this.mesIndex];
        this.form.ano = this.ano;
        this.form.mesIndex = this.mesIndex;
        const formData = new FormData();
        if (this.fileBol.name) formData.append("fileBoleto", this.fileBol);
        if (this.fileNota.name) formData.append("fileNota", this.fileNota);
        formData.append("form", JSON.stringify(this.form));
        formData.append("grupo", this.grupo);

        const app = this;
        this.loadingData = true;
        this.log = "Preparando envio de email...";

        axios
          .post(
            `${process.env.VUE_APP_API}/api/v1/financeiro/faturamento/envio`,
            formData,
            {
              headers: {
                Authorization: this.$store.getters.authToken,
                "Content-Type": "multipart/form-data"
              }
            }
          )
          .catch(() => {
            this.loadingData = false;
            this.error = 'Erro ao enviar';
          });
      } else {
        this.error = 'Preencha o email, valor por smss, cnpj e razao social';
      }
    },
    calcValorTotal() {
      // pegar media de valor dos clientes
      this.form.valorTotal = 0;
      this.cliSemValorSms = [];

      for (let i = 0; i < this.form.clientes.length; i += 1) {
        const cliente = this.form.clientes[i];
        if (!cliente.valorSms) cliente.valorSms = 0;
        const valorSms = parseFloat(cliente.valorSms);

        if (valorSms === 0) {
          this.cliSemValorSms.push(cliente);
        }

        this.form.valorTotal += valorSms * cliente.entregues;
      }
    },
    choseNota(e) {
      this.fileNota = e.target.files[0];
    },
    choseBol(e) {
      this.fileBol = e.target.files[0];
    }
  },
  sockets: {
    logRelFinanceiroPainel(data) {
      console.log(data);

      if (data.final) {
        this.log = false;
        this.loadingData = false;
        if (!data.success) {
          this.error = data.err;
        } else {
          this.form.clientes = data.clientes;
          this.form.totalEntregues = data.entregues;
          let diaVenc = false;
          this.cliSemValorSms = [];

          for (let index = 0; index < data.clientes.length; index++) {
            const cliente = data.clientes[index];
            if (cliente.emailsFaturamento) {
              this.form.emailDestinatiario = cliente.emailsFaturamento;
            }
            if (cliente.vencimento) diaVenc = moment(cliente.vencimento).date();
            if (cliente.cnpj) this.form.cnpj = cliente.cnpj;
            if (cliente.razaoSocial) {
              this.form.razaoSocial = cliente.razaoSocial;
            }
            if (!cliente.valorSms) this.cliSemValorSms.push(cliente);
          }

          this.form.vencimento = diaVenc
            ? moment()
                .date(diaVenc)
                .format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD");

          this.calcValorTotal();
        }
      } else {
        this.log = data.msg;
      }
    },
    logEnvioEmailFinanceiro(data) {
      if (data.final) {
        this.loadingData = false;
        this.log = false;
        if (!data.success) {
          this.error = data.err;
        } else {
          this.successMsg = data.msg;
          EventBus.$emit("clienteFaturado", this.grupo._id);
        }
      } else {
        this.log = data.msg;
      }
    }
  },
  async mounted() {
    this.log = `Buscando resumo mensal do grupo de clientes ${this.grupo.nome}. Aguarde...`;
    await this.$http.get(
      `/v1/financeiro/faturamento/getResumoCliente/${this.mesIndex}/${this.ano}/${this.grupo._id}`
    );

    this.form.msgCustom = `Boa tarde.\nSegue fechamento referente ao envio de SMS do mes de ${this.meses[this.mesIndex]} de ${this.ano}, anexo Relatório, Nota Fiscal e boleto.`
  }
};
</script>
